import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { message } from 'antd'
import { SET_USER } from '../../actions/auth'
import usersService from '../../services/users'
import Spinner from '../../components/Spinner'

const OAuthCallback = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get token from URL query params
        const urlParams = new URLSearchParams(location.search)
        const token = urlParams.get('token')
        const error = urlParams.get('error')

        if (error) {
          message.error('OAuth authentication failed. Please try again.')
          history.push('/login')
          return
        }

        if (!token) {
          message.error('No authentication token received.')
          history.push('/login')
          return
        }

        // Store token in localStorage
        localStorage.setItem('WiseAcademy-token', token)

        // Fetch user data using the token
        try {
          const response = await usersService.getMe(token)
          const userData = {
            user: response.user || response,
            token: token
          }

          // Store in localStorage
          window.localStorage.setItem('WiseAcademy-user', JSON.stringify(userData))

          // Dispatch to Redux
          dispatch({ type: SET_USER, user: userData })

          // Subscribe to notifications
          const subscribeUser = require('../../subscription').default
          subscribeUser()

          // Redirect to app
          message.success('Successfully signed in!')
          history.push('/app')
        } catch (error) {
          console.error('Error fetching user data:', error)
          message.error('Failed to fetch user data. Please try again.')
          history.push('/login')
        }
      } catch (error) {
        console.error('OAuth callback error:', error)
        message.error('Authentication failed. Please try again.')
        history.push('/login')
      }
    }

    handleCallback()
  }, [location, history, dispatch])

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column'
    }}>
      <Spinner size="large" />
      <p style={{ marginTop: '20px', fontSize: '16px' }}>Completing authentication...</p>
    </div>
  )
}

export default OAuthCallback

